import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';

export default class Annual extends Base {
	constructor(props) {
		super(props);
		this.state = {
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			caller: props.Caller,
			data: null,
			loading: true
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/annual/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.setState({ loading: false });
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.taxPercent)) this.state.data.record.taxPercent = 0;

		this.httpPost("api/v1/annual/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			title: this.state.data.record.title,
			accessMode: this.state.data.record.accessMode,
			taxPercent: parseInt(this.state.data.record.taxPercent),
			from: this.convertMomentToDb(this.state.data.record.from),
			to: this.convertMomentToDb(this.state.data.record.to),
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("سال مالی جدید با موفقیت ایجاد شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable">
				<div className="modal-content">
					<div className="modal-body" style={{ "padding": "0" }}>
						<div className="modal-header modal-header-info">
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">
								{this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات سال مالی" : "افزودن سال مالی جدید"}
							</h4>
						</div>
						<div className="modal-body">
							<div className="container-fluid">
								<div className="row">
									<div className="col-lg-12">
										<div className="form-group">
											<label className="form-label">عنوان</label>
											<div className="form-control-wrap">
												<input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
											</div>
										</div>
									</div>
									<div className="col-lg-3">
										<div className="form-group">
											<label className="form-label">شروع</label>
											<div className="form-control-wrap">
												<DatePicker
													inputReadOnly={true}
													className="form-control input-sm persian-date"
													placeholder={"تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.state.data.record.from = e }}
													value={this.getFormatedDateForDatePicker(this.state.data.record.from)}
												/>
											</div>
										</div>
									</div>
									<div className="col-lg-3">
										<div className="form-group">
											<label className="form-label">پایان</label>
											<div className="form-control-wrap">
												<DatePicker
													inputReadOnly={true}
													className="form-control input-sm persian-date"
													placeholder={"تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.state.data.record.to = e }}
													value={this.getFormatedDateForDatePicker(this.state.data.record.to)}
												/>
											</div>
										</div>
									</div>
									<div className="col-lg-12">
										<div className="form-group">
											<label className="form-label">نرخ مالیات</label>
											<div className="form-control-wrap">
												<input className="form-control" type="text" defaultValue={this.state.data.record.taxPercent} onChange={e => this.state.data.record.taxPercent = e.target.value} />
											</div>
										</div>
									</div>
									<div className="col-lg-12">
										<div className="form-group">
											<label className="form-label">نحوه دسترسی به این سال مالی</label>
											<select className="form-control" defaultValue={this.state.data.record.accessMode} onChange={(e) => this.state.data.record.accessMode = parseInt(e.target.value)}>
												<option value="0">همه کاربران کسب و کار مجاز هستند</option>
												<option value="1">فقط کاربران تعیین شده در دسترسی شرکتها مجاز به دسترسی به این سال مالی هستند</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
							<button type="submit" onClick={e => this.save(e)} className="btn btn-success">
								ذخیره
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm()
			];

		return contents;
	}
}